import { Component } from '@angular/core';


@Component({
  selector: 'app-hero-nutricion-dietetica',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-nutricion-dietetica.component.css'
})
export class HeroNutricionDieteticaComponent {

  name="Programa de Nutrición y Dietética";
  description = "Asesoría y control sobre alimentación saludable y hábitos nutricionales adecuados, adaptados a las necesidades personales y laborales de cada colaborador.";
  description2 = "";
  routeLogo = "assets/img/enterprise/menu/nutricionDieta.svg";
  routeImage = "assets/img/enterprise/hero/fotoNutricion.svg"

}
